module.exports = __webpack_public_path__ + "img/app-store.628ee0eb.png";